import React from 'react';
import { toast } from 'react-toastify';

export default function WizardNav({
  step, setStep, handleBack, avancarButtonRef, caixaInputRef,
  registrarButtonRef, caixas, pinValidated, canAdvanceFromStep3
}) {
  if (step <= 1) return null;

  return (
    <div className="flex justify-between items-center gap-8 px-2 pb-4 mt-14 mb-10 border-b border-gray-200">
      <button onClick={handleBack} className="text-blue-600 flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-chevron-left-icon"><circle cx="12" cy="12" r="10"/><path d="m14 16-4-4 4-4"/></svg>
        <span>Voltar</span>
      </button>
      {step < 4 && (
        <button
          ref={avancarButtonRef}
          onClick={() => {
            if (step === 2) {
              setStep(3);
              setTimeout(() => caixaInputRef.current?.focus(), 0);
            } else if (step === 3) {
              if ((caixas?.length || 0) > 0) {
                if (!canAdvanceFromStep3()) {
                  setTimeout(() => caixaInputRef.current?.focus(), 0);
                  return;
                }
                setStep(4);
                setTimeout(() => registrarButtonRef.current?.focus(), 0);
              } else {
                toast.warn('Adicione ao menos uma caixa', { autoClose: 4000 });
                setTimeout(() => caixaInputRef.current?.focus(), 0);
              }
            }
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              if (step === 2) {
                setStep(prev => prev + 1);
                setTimeout(() => caixaInputRef.current?.focus(), 0);
              } else if (step === 3) {
                if ((caixas?.length || 0) > 0) {
                  if (!canAdvanceFromStep3()) {
                    setTimeout(() => caixaInputRef.current?.focus(), 0);
                    return;
                  }
                  setStep(prev => prev + 1);
                  setTimeout(() => registrarButtonRef.current?.focus(), 0);
                } else {
                  toast.warn('Adicione ao menos uma caixa', { autoClose: 4000 });
                  setTimeout(() => caixaInputRef.current?.focus(), 0);
                }
              }
            }
          }}
          disabled={step === 2 && !pinValidated}
          className={`text-blue-600 flex items-center gap-4 ${step === 2 && !pinValidated ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <span>Avançar</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-chevron-right-icon"><circle cx="12" cy="12" r="10"/><path d="m10 8 4 4-4 4"/></svg>
        </button>
      )}
    </div>
  );
}